import { useEffect, useState } from 'react';
import classes from './SettingOutsourcingToMail.module.scss';
import AddButton from '../../uikit/atoms/buttons/AddButton';
import SetToOutMailTable from './table/SetToOutMailTable';
import AddOutsourcingMailModal from './modal/AddOutsourcingMailModal';
import { AddressInfoType } from '../../../types';
import { useGetAddressList } from '../../../hooks/api/address/useGetAddress';
import AddCcMailModal from './modal/AddCcMailModal';
import SetCcMailTable from './table/SetCcMailTable';
const SettingOutsourcingCcMail = () => {
  const [isShowAddDialog, setIsShowAddDialog] = useState(false);
  const [addressList, setAddressList] = useState<AddressInfoType[]>([]);
  const { getCcAddressList } = useGetAddressList();
  useEffect(() => {
    const fetchCcAddressList = async () => {
      const res = await getCcAddressList('', '');
      setAddressList(res);
    };
    fetchCcAddressList();
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.title}>CC</div>
        <AddButton
          label={'新規'}
          disabled={false}
          onClick={(event: any) => {
            setIsShowAddDialog(true);
          }}
        />
      </div>
      <div className={classes.table}>
        <SetCcMailTable
          addressList={addressList}
          getAddressList={getCcAddressList}
          setAddressList={setAddressList}
        />
      </div>
      {isShowAddDialog && (
        <AddCcMailModal
          open={isShowAddDialog}
          setOpen={setIsShowAddDialog}
          getAddressList={getCcAddressList}
          setAddressList={setAddressList}
        />
      )}
    </div>
  );
};

export default SettingOutsourcingCcMail;
